<template>
  <div class="subjects-list">
    <div class="score-hd" style="padding:10px">
      当前题目数：{{ subjectsTotal.subjectsTotalNum }} 
      总分：
      <span style="color: red"
        >{{
          parseInt(subjectsTotal.subjectsTotalScore) ==
          subjectsTotal.subjectsTotalScore
            ? subjectsTotal.subjectsTotalScore
            : String(subjectsTotal.subjectsTotalScore.toFixed(2)).split(
                "."
              )[1] == "00"
            ? String(subjectsTotal.subjectsTotalScore.toFixed(2)).split(".")[0]
            : subjectsTotal.subjectsTotalScore.toFixed(2)
        }}分</span
      >
    </div>
    <el-table
      :data="subjectsTotal.tableData"
      :row-key="getRowKeys"
      style="width: 100%"
      max-height="605"
      size="mini"
      border
    >
      <el-table-column label="题号" width="110" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            placement="top-start"
            v-if="
              (scope.row.th &&
                scope.row.th.length + scope.row.name &&
                scope.row.name.length) > 10
            "
          >
            <div slot="content">{{ scope.row.th }}、{{ scope.row.name }}</div>
            <span
              >{{ scope.row.th }}{{ scope.row.start
              }}{{
                scope.row.end
                  ? scope.row.start == scope.row.end
                    ? ""
                    : `-${scope.row.end}`
                  : scope.row.end
              }}、{{ scope.row.name.slice(0, 6) }}...</span
            >
          </el-tooltip>
          <span v-else
            >{{ scope.row.th }}{{ scope.row.start
            }}{{
              scope.row.end
                ? scope.row.start == scope.row.end
                  ? ""
                  : `-${scope.row.end}`
                : scope.row.end
            }}、{{ scope.row.name }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="v2" label="题型" width="75" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 2">选择题</span>
          <span v-if="scope.row.type == 1">填空题</span>
          <span v-if="scope.row.type == 3">解答题</span>
          <span v-if="scope.row.type == 4">作文（英）</span>
          <span v-if="scope.row.type == 5">作文（语）</span>
          <span v-if="scope.row.type == 6">选做题</span>
        </template>
      </el-table-column>
      <el-table-column label="分值" width="50" align="center">
        <template slot-scope="scope">{{
          parseInt(scope.row.totalScore) == scope.row.totalScore
            ? scope.row.totalScore
            : String(scope.row.totalScore.toFixed(2)).split(".")[1] == "00"
            ? String(scope.row.totalScore.toFixed(2)).split(".")[0]
            : scope.row.totalScore.toFixed(2)
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="60" align="center">
        <template slot-scope="scope">
          <span
            style="
              font-size: 12px;
              display: inline-block;
              color: #409eff;
              cursor: pointer;
              margin-right: 5px;
            "
            class="el-icon-edit"
            @click="worEdit(scope)"
          >
          </span>
          <span
            style="
              font-size: 12px;
              display: inline-block;
              color: red;
              cursor: pointer;
            "
            class="el-icon-delete"
            @click="worDel(scope)"
          ></span>
        </template>
      </el-table-column>
    </el-table>
    <!--弹窗 -->
    <subject-blank
      @submit-blank="submitBlank2"
      v-model="fillBlankVisible2"
      :type="'填空题'"
      :subject="updateSubject"
    />
    <subject-objective
      v-model="objectiveVisible"
      type="选择题"
      :subject="updateSubject"
      @submit-objective="submitObjective"
    />
    <subject-answer
      v-model="answerVisible"
      type="解答题"
      @submit-answer="submitAnswer"
      :subject="updateSubject"
    />
    <subject-write-en
      v-model="writeEnVisible"
      :subject="updateSubject"
      type="英语作文"
      @submit-write="submitWriteEn"
    />
    <subject-write
      v-model="writeVisible"
      :subject="updateSubject"
      type="语文作文"
      @submit-write="submitWrite"
    />
    <subject-choose
      v-model="chooseVisible"
      :subject="updateSubject"
      type="选做题"
      @submit-choose="submitChoose"
    ></subject-choose>
  </div>
</template>
<script>
/** 试题列表 */
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import SubjectBlank from "@/subjects/blank/Blank";
import SubjectObjective from "@/subjects/objective/Objective";
import SubjectAnswer from "@/subjects/answer/Answer";
import SubjectWriteEn from "@/subjects/writeEn/WriteEn";
import SubjectWrite from "@/subjects/write/Write";
import SubjectChoose from "@/subjects/choose/Choose";

export default {
  components: {
    // 新组件
    SubjectBlank,
    SubjectObjective,
    SubjectAnswer,
    SubjectWriteEn,
    SubjectWrite,
    // BlankModal,
    SubjectChoose,
  },
  data() {
    return {
      updateSubject: undefined,
      updateSubjectIdx: 0,
      subjectsTotalScore: 0,
      subjectsTotalNum: 0,
      // 新弹窗显示或隐藏
      fillBlankVisible: false,
      fillBlankVisible2: false,
      objectiveVisible: false,
      answerVisible: false,
      writeEnVisible: false,
      writeVisible: false,
      chooseVisible: false,
      writeModel: undefined,
      visibleMap: {
        //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
        1: "fillBlankVisible2",
        2: "objectiveVisible",
        3: "answerVisible",
        4: "writeEnVisible",
        5: "writeVisible",
        6: "chooseVisible",
      },
    };
  },
  computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
      visibleDialog: "answerPanel/visibleDialog",
      visibleDialogIndex: "answerPanel/visibleDialogIndex",
    }),
    ...mapState("card", {
      subjects: (state) => state.subjects,
      pageCell: (state) => state.pageCell,
    }),
    subjectsTotal() {
      console.log("this.subjects", this.subjects);
      let num = 0;
      let score = 0;
      const obj = {};
      this.subjects.length &&
        this.subjects.forEach(subject => {
          if (subject.type !== 7) {
            score += Number(subject.totalScore || 0);
            subject.items?.forEach(item => {
              if (item.type !== 7) {
                num += 1;
              }
            });
          }
      });
      obj.subjectsTotalScore = score;
      obj.subjectsTotalNum = num;
      obj.tableData = JSON.parse(JSON.stringify(this.subjects || [])).filter(
        item => item.type !== 7
      ) || [];
      return obj;
    },
  },
  methods: {
    ...mapMutations({
      addSubject: "card/addSubject",
      // append: "subjects/append",
      append: "card/append",
      resetPageCell: "card/resetPageCell",
      deleteSubject: "card/deleteSubject",
      updateSubjects: "card/updateSubjects",
      sortSubjectByIndex: "card/sortSubjectByIndex",
    }), //参数的变动
    getRowKeys(row) {
      return row.id;
    },
    openDialogByType(subject, index) {
      this[this.visibleMap[subject.type]] = true;
      this.updateSubject = subject;
      this.updateSubjectIdx = index;
    },
    worEdit(scop) {
      const { $index } = scop;
      const subject = this.subjects[$index];
      this.openDialogByType(subject, $index);
      // this.isEdit = true;
      // this.objectiveDV = true;
    },
    worDel(scop) {
      this.$confirm("删除后会影响试题布局，确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async (item) => {
          const { $index } = scop;
          await this.deleteSubject($index); // 通过下标删除指定元素
          await this.resetPageCell({
            acCardPanes: this.answerSheet.acCardPanes,
            index: $index - 1 < 0 ? 0 : $index - 1,
            byDel: true,
          });
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    submitBlank(data) {
      if (data) { 
        // this.addSubject(data);
        this.fillBlankVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitBlank2(data) {
      if (data) {
        this.fillBlankVisible2 = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitObjective(data) {
      if (data) {
        this.objectiveVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitAnswer(data) {
      console.log('submitAnswer:::::', data);
      if (data) {
        this.answerVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitWriteEn(data) {
      if (data) {
        // this.addSubject(data);
        this.writeEnVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitWrite(data) {
      if (data) {
        // this.addSubject(data);
        this.writeVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    submitChoose(data) {
      if (data) {
        this.chooseVisible = false;
        this.updateSubject
          ? this.updateSubjectsByindex(data)
          : this.append(data);
      }
    },
    //添加修添加题型
    async updateSubjectsByindex(updateSubject) {
      const index = this.updateSubjectIdx;
      // 这里的编辑更新肯定需要更改题型的html和高度 不可能保存之前的数据
      updateSubject.setFromEdit(true);
      await this.updateSubjects({
        index: index,
        data: updateSubject,
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: index,
      });
      if (updateSubject.type != 2) {
        return;
      }
      // 这样写是为了 dom更新之后 处理选择题 精确计算选择题的高度
      updateSubject = await setObjectiveHeight(updateSubject);
      await this.updateSubjects({
        index: index,
        data: new ObjectiveModel(updateSubject),
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: index,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.subjects-list {
  padding: 0 5px;
}
</style>